import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../api";
import theme from "../styles/theme";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const res: any = await loginUser(username, password);
      if (res.success) {
        localStorage.setItem("user", JSON.stringify(res.user));
        const hasSuperAdminFlag =
          res.user?.is_superadmin === true ||
          res.user?.is_superadmin === 1 ||
          res.user?.is_superadmin === "1";

        if (res.user.role === "player") {
          navigate(`/player/${res.user.id}`); // Redirection vers PlayerProfile
        } else if (res.user.role === "coach") {
          navigate("/dashboard"); // Redirection vers le tableau de bord pour les coachs
        } else if (["staff", "superadmin"].includes(res.user.role) || hasSuperAdminFlag) {
          navigate("/superadmin-passwords");
        } else {
          setError("Rôle utilisateur inconnu.");
        }
        window.dispatchEvent(new Event("storage")); // Déclenche un événement pour mettre à jour l'état global
      } else {
        setError(res.error || "Erreur login");
      }
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{
        background: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
        padding: '40px',
        width: '100%',
        maxWidth: '400px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
        <img src="/images/logo.png" alt="Logo" style={{ marginBottom: 24, width: 80, height: 80 }} />
        <h1 style={{
          fontSize: '2.5rem',
          fontWeight: 700,
          marginBottom: 24,
          color: theme.palette.primary.main,
          textAlign: 'center',
          fontFamily: theme.typography.fontFamily
        }}>
          Connexion
        </h1>
        <input
          style={{
            border: `1px solid ${theme.palette.secondary.main}`,
            borderRadius: theme.shape.borderRadius,
            padding: '12px',
            marginBottom: 16,
            width: '100%',
            textAlign: 'center',
            fontSize: '1rem',
            outline: 'none',
            color: theme.palette.text.primary,
            fontFamily: theme.typography.fontFamily
          }}
          placeholder="Nom d'utilisateur"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <div
          style={{
            position: 'relative',
            width: '100%',
            marginBottom: 16,
          }}
        >
          <input
            style={{
              border: `1px solid ${theme.palette.secondary.main}`,
              borderRadius: theme.shape.borderRadius,
              padding: '12px 44px 12px 12px',
              width: '100%',
              textAlign: 'center',
              fontSize: '1rem',
              outline: 'none',
              color: theme.palette.text.primary,
              fontFamily: theme.typography.fontFamily
            }}
            placeholder="Mot de passe"
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type="button"
            onClick={() => setShowPassword((v) => !v)}
            aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
            title={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
            style={{
              position: 'absolute',
              right: 10,
              top: '50%',
              transform: 'translateY(-50%)',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              padding: 0,
              color: theme.palette.secondary.main,
              lineHeight: 0,
            }}
          >
            {showPassword ? (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M3 3L21 21"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10.58 10.58C10.21 10.95 10 11.46 10 12C10 13.1 10.9 14 12 14C12.54 14 13.05 13.79 13.42 13.42"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.88 5.09C10.56 4.93 11.27 4.85 12 4.85C16.5 4.85 20.27 7.78 21.54 12C21.18 13.19 20.58 14.28 19.8 15.2"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.61 6.61C4.87 7.78 3.54 9.69 2.46 12C3.73 16.22 7.5 19.15 12 19.15C13.86 19.15 15.58 18.63 17.04 17.73"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M2.46 12C3.73 7.78 7.5 4.85 12 4.85C16.5 4.85 20.27 7.78 21.54 12C20.27 16.22 16.5 19.15 12 19.15C7.5 19.15 3.73 16.22 2.46 12Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
              </svg>
            )}
          </button>
        </div>
        <button
          onClick={handleLogin}
          style={{
            background: theme.palette.primary.main,
            color: theme.palette.common.white,
            fontWeight: 600,
            padding: '12px',
            borderRadius: theme.shape.borderRadius,
            width: '100%',
            marginBottom: 8,
            fontSize: '1rem',
            border: 'none',
            cursor: 'pointer',
            fontFamily: theme.typography.fontFamily,
            transition: 'background 0.2s'
          }}
          onMouseOver={e => (e.currentTarget.style.background = theme.palette.primary.dark)}
          onMouseOut={e => (e.currentTarget.style.background = theme.palette.primary.main)}
        >
          Se connecter
        </button>
        <a
          href="/change-password"
          style={{
            display: 'block',
            color: theme.palette.secondary.main,
            textAlign: 'center',
            marginTop: 8,
            textDecoration: 'underline',
            fontSize: '0.95rem',
            cursor: 'pointer',
            fontFamily: theme.typography.fontFamily
          }}
        >
          Mot de passe oublié ou initialiser ?
        </a>
        {error && <p style={{
          color: theme.palette.error.main,
          marginTop: 16,
          textAlign: 'center',
          fontFamily: theme.typography.fontFamily
        }}>
          {error}
        </p>}
      </div>
    </div>
  );
}
